import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TestComponent } from './components/test/test.component';
import { SelectAddressComponent } from './components/select-address/select-address.component';
import { QuickAddComponent } from './components/quick-add/quick-add.component';
import { NgxNumberSpinnerModule } from '../ngx-number-spinner/ngx-number-spinner.module';
import { CategoryComponentComponent } from './components/category-component/category-component.component';
import { ProductRoutingModule } from '../product/product-routing.module';
import { TestimonialSliderComponent } from '../home/components/testimonial-slider/testimonial-slider.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DownloadAppComponent } from '../home/components/download-app/download-app.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import * as fromShared from '../shared/store/reducers';
import { DefaultRedirectionScreenComponent } from './components/default-redirection-screen/default-redirection-screen.component';
import { AppFooterComponent } from './components/shared-component/app-footer-component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedEffects } from './store/effects/shared.effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../core/interceptor/auth.interceptor';
import { LoaderInterceptor } from '../core/interceptor/loader.interceptor';
import { SharedConfigService } from '../core/services/app-config.service';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppFileUploadEmitter } from './UI-components/uploadFileEmitter';
import { BrandModalComponent } from './components/brand-modal/brand-modal.component';
import { SearchPipe } from '../core.pipes';

@NgModule({
  declarations: [
    ConfirmDialogComponent, 
    NotFoundComponent, 
    HeaderComponent,
    FooterComponent, 
    TestComponent, 
    SelectAddressComponent, 
    QuickAddComponent,
    TestimonialSliderComponent,
    CategoryComponentComponent,
    DownloadAppComponent, 
    ContactUsComponent, 
    DefaultRedirectionScreenComponent, 
    AppFooterComponent,
    AppFileUploadEmitter,
    BrandModalComponent,
    SearchPipe,
  ],
  imports: [
    CommonModule,
    ProductRoutingModule,
    AccordionModule.forRoot(),
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    NgxNumberSpinnerModule,
    SlickCarouselModule,
    NgcCookieConsentModule,
    InfiniteScrollModule,
    StoreModule.forFeature(fromShared.sharedFeatureKey,fromShared.sharedReducer),
    EffectsModule.forFeature([SharedEffects]),
    StoreDevtoolsModule.instrument({maxAge:25})
    
  ],
  exports:[
    HeaderComponent,
    FooterComponent,
    SelectAddressComponent,
    QuickAddComponent,
    CategoryComponentComponent,
    TestimonialSliderComponent,
    DefaultRedirectionScreenComponent,
    DownloadAppComponent,
    AppFooterComponent,
    AppFileUploadEmitter,
    BrandModalComponent,
    SearchPipe
  ],
  providers:[
    // provideStoreDevtools({ maxAge: 25 }),
    {provide:HTTP_INTERCEPTORS,useClass:AuthInterceptor,multi:true},
    {provide:HTTP_INTERCEPTORS,useClass:LoaderInterceptor,multi:true},
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SharedConfigService],
      useFactory: (sharedConfigService: SharedConfigService) => {
        return () => {
          //Make sure to return a promise!
          return sharedConfigService.loadAppConfig()
        };
      }
    },
    
  ]
})
export class SharedModule { }
